export enum Module {
  SELF_REPORT = 'SELF_REPORT',
  GAME = 'GAME',
  VIDEO = 'VIDEO',
}

export const moduleTypeStringMap: Record<ModuleType, string> = {
  SELF_REPORT: 'selfReport',
  GAME: 'game',
  VIDEO: 'video',
};

export const moduleTypeNameMap: Record<ModuleType, string> = {
  SELF_REPORT: '성향파악',
  GAME: '전략게임',
  VIDEO: '영상면접',
};

export type ModuleType = keyof typeof Module;
